import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

export function TestBatchesCleanup({ onDone }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const p = await api.testBatchesPreview();
      if (!p.batches.length) return toast.info("Nessun lotto di test trovato");
      const names = [...new Set(p.batches.map((b) => `${b.prefix || "—"} · ${b.store_name}`))].slice(0, 12).join("\n");
      if (!window.confirm(`Eliminare ${p.batches.length} lotti di test (${p.codes} codici, ${p.plays} giocate collegate)?\n\n${names}${p.batches.length > 12 ? "\n…" : ""}\n\nI lotti reali (es. SA, MI, WA) non vengono toccati.`)) return;
      const r = await api.testBatchesCleanup();
      toast.success(`Rimossi ${r.batches} lotti, ${r.codes} codici, ${r.plays} giocate`);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Pulizia non riuscita");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button size="sm" variant="ghost" className="gap-1.5 text-muted-foreground hover:text-destructive" disabled={busy} onClick={run} data-testid="test-batches-cleanup-button">
      <Trash2 className="h-3.5 w-3.5" /> Rimuovi lotti di test
    </Button>
  );
}
